/**
 * Unit: milliseconds
 */
export const PREBID_TIMEOUT = 1500;
